const FIELD_SELECTOR = 'input.field-input[type="date"], select.field-input';
function getFieldInput(target) {
  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return null;
  return target.matches(FIELD_SELECTOR) ? target : null;
}
function hasFieldValue(input) {
  if (input instanceof HTMLSelectElement) {
    return input.value !== "" && input.value !== "---" || input.selectedIndex === -1;
  }
  return input.value !== "";
}
function updateFieldSelectedState(input) {
  const hasValue = hasFieldValue(input);
  if (input.hasAttribute("selected") === hasValue) return;
  input.toggleAttribute("selected", hasValue);
}
function updateFieldFromEvent(event) {
  const input = getFieldInput(event.target);
  if (!input) return;
  updateFieldSelectedState(input);
  if (event.type === "change" && input instanceof HTMLSelectElement && input.hasAttribute("data-open")) {
    input.removeAttribute("data-open");
  }
}
function openSelect(event) {
  const input = getFieldInput(event.target);
  if (!(input instanceof HTMLSelectElement) || input.hasAttribute("data-open")) return;
  input.setAttribute("data-open", "");
}
function closeSelect(event) {
  const input = getFieldInput(event.target);
  if (!(input instanceof HTMLSelectElement) || !input.hasAttribute("data-open")) return;
  input.removeAttribute("data-open");
}
function updateFields(root = document) {
  root.querySelectorAll(FIELD_SELECTOR).forEach(updateFieldSelectedState);
}
updateFields();
document.addEventListener("focusin", updateFieldFromEvent);
document.addEventListener("input", updateFieldFromEvent);
document.addEventListener("change", updateFieldFromEvent);
document.addEventListener("mousedown", openSelect);
document.addEventListener("blur", closeSelect, true);
document.addEventListener("reset", (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  requestAnimationFrame(() => updateFields(event.target));
});
export {
  updateFieldSelectedState
};
